import { connect } from 'react-redux';
import { closeModal } from 'common/src/app/actions/components/modalActions';
import MagicMoverAwardModal from './MagicMoverAwardModal';

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeModal()),
});

export default connect(null, mapDispatchToProps)(MagicMoverAwardModal);
